module.exports = __webpack_public_path__ + "img/ic_circle_cross_red.21b072ba.svg";